import './AppIcon.css';
import { createRuntimeFn as _7a468 } from '@vanilla-extract/recipes/createRuntimeFn';
export var icon = _7a468({defaultClassName:'_1dtfpz51-3-15-1',variantClassNames:{fadeIn:{true:'_1dtfpz52-3-15-1'}},defaultVariants:{},compoundVariants:[]});